import React from "react";
import useStream from "./useStream";
import Stream from "./Components/Stream";

const StreamIndex: React.FC = () => {

  return <Stream />;
};
export default StreamIndex;
